var CourtInfoInquiry = function () { return import('~/pages/system-tools/court-info-inquiry.vue'); };
var CourtInfoInquiryAll = function () { return import('~/pages/system-tools/court-info-inquiry-all.vue'); };
export default [
    {
        // 法院案件查询
        path: '/system-tools/court-info-inquiry',
        name: 'court-info-inquiry',
        component: CourtInfoInquiry
    },
    {
        // 法院案件查询
        path: '/system-tools/court-info-inquiry-all',
        name: 'court-info-inquiry-all',
        component: CourtInfoInquiryAll
    }
];
